import { effect } from "@preact/signals";
import Phaser from "phaser";
import { TILE, VIEW_H, VIEW_W } from "@/config";
import { tid } from "@/assets/tileAtlas";
import { screen } from "@/state/store";

/** Decorative background behind the HTML start panel; hands over to the World scene when the player starts. */
export class TitleScene extends Phaser.Scene {
  constructor() {
    super("Title");
  }

  create(): void {
    const cols = Math.ceil(VIEW_W / TILE) + 1;
    const rows = Math.ceil(VIEW_H / TILE) + 1;
    const data: number[][] = [];
    const decor: number[][] = [];
    const flowers = ["flower_yellow", "flower_white", "flower_red", "tuft_a", "bush"].map(tid);
    for (let y = 0; y < rows; y++) {
      const row: number[] = [];
      const drow: number[] = [];
      for (let x = 0; x < cols; x++) {
        const r = (x * 7 + y * 13) % 17;
        row.push(r === 9 ? tid("grass_b") : r === 3 ? tid("grass_c") : tid("grass"));
        drow.push(r === 5 || r === 0 ? (flowers[(x + y) % flowers.length] as number) : -1);
      }
      data.push(row);
      decor.push(drow);
    }
    const map = this.make.tilemap({ data, tileWidth: TILE, tileHeight: TILE });
    const tiles = map.addTilesetImage("tiles", "tiles", TILE, TILE, 0, 0);
    if (tiles) {
      map.createLayer(0, tiles, 0, 0)?.setAlpha(0.7);
      const layer = map.createBlankLayer("decor", tiles);
      decor.forEach((drow, y) => drow.forEach((v, x) => v >= 0 && layer?.putTileAt(v, x, y)));
      layer?.setAlpha(0.7);
    }

    const monster = this.add.sprite(VIEW_W - 70, VIEW_H - 60, "mon-fish", 0).setScale(3);
    monster.play("mon-fish-idle");
    const blob = this.add.sprite(70, VIEW_H - 50, "mon-slime", 0).setScale(3);
    blob.play("mon-slime-idle");
    const hero = this.add.sprite(VIEW_W / 2, VIEW_H - 30, "hero-boy", 0).setScale(3);
    hero.play("hero-boy-walk-down");

    const dispose = effect(() => {
      if (screen.value === "world" && this.scene.isActive("Title")) {
        this.scene.start("World");
      }
    });
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => dispose());
  }
}
